import React from 'react';

export function Checkbox({
  label,
  checked,
  onChange,
  id,
  error,
  className = '',
  ...props
}) {
  const checkboxId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <label
      htmlFor={checkboxId}
      className={`flex items-start gap-3 cursor-pointer group ${className}`}
    >
      <div className="relative flex-shrink-0 mt-0.5">
        <input
          type="checkbox"
          id={checkboxId}
          checked={checked}
          onChange={onChange}
          className="sr-only peer"
          {...props}
        />
        <div
          className={`
            w-5 h-5 border bg-secondary
            peer-checked:bg-foreground peer-checked:border-foreground
            peer-focus-visible:ring-2 peer-focus-visible:ring-foreground peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-primary
            transition-all duration-normal
            ${error ? 'border-red-500' : 'border-border-light group-hover:border-subtle'}
          `}
        />
        <svg
          className="absolute top-0.5 left-0.5 w-4 h-4 text-primary opacity-0 peer-checked:opacity-100 transition-opacity duration-normal pointer-events-none"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={3}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <span className="text-small text-subtle group-hover:text-foreground transition-colors duration-normal">
        {label}
      </span>
    </label>
  );
}

export function CheckboxGroup({
  label,
  options = [],
  values = [],
  onChange,
  error,
  maxSelections,
  className = '',
}) {
  const handleChange = (optionValue, isChecked) => {
    if (isChecked) {
      if (maxSelections && values.length >= maxSelections) {
        return;
      }
      onChange([...values, optionValue]);
    } else {
      onChange(values.filter((v) => v !== optionValue));
    }
  };

  return (
    <div className={`space-y-3 ${className}`}>
      {label && (
        <p className="text-small text-foreground">
          {label}
          {maxSelections && (
            <span className="text-muted ml-2">(Select up to {maxSelections})</span>
          )}
        </p>
      )}
      <div className="space-y-3">
        {options.map((option) => (
          <Checkbox
            key={option.value}
            label={option.label}
            checked={values.includes(option.value)}
            onChange={(e) => handleChange(option.value, e.target.checked)}
            error={error}
          />
        ))}
      </div>
      {error && <p className="text-caption text-red-400">{error}</p>}
    </div>
  );
}

export default Checkbox;
